import React, { useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import URL from "../functions/URLString";

// const images = [
//     {
//         link:"https://images.pexels.com/photos/268533/pexels-photo-268533.jpeg?cs=srgb&dl=pexels-pixabay-268533.jpg&fm=jpg",
//     },
//     {
//         link:"https://media.istockphoto.com/id/619503842/photo/wazir-khan-mosque-lahore-pakistan.jpg?s=612x612&w=0&k=20&c=3vrR52_8PkripvQhwP_TOVCW4e9xvv4lIjlSRyPd9Hs=",
//     },
//     {
//         link:"https://media.istockphoto.com/id/538601654/photo/sunehri-mosque-peshawar-pakistan.jpg?s=612x612&w=0&k=20&c=-P-90BMVitvcbTp46wmt-0iojU7uK_Wbme4erbpDjaE=",
//     },
//     {
//         link:"https://www.esa.int/var/esa/storage/images/esa_multimedia/images/2022/07/webb_s_first_images_-_highlights/24358377-1-eng-GB/Webb_s_first_images_-_highlights_pillars.jpg",
//     },
// ]

function ImageSlider({ images, stateSingleJob }) {
  const [image, setImage] = useState(images[0]);

  const next = () => {
    if (image === images[images.length - 1]) {
      setImage(images[0]);
      return image;
    } else {
      images.map((im, index) => {
        if (im === image) {
          setImage(images[index + 1]);
        }
        return image;
      });
    }
    return image;
  };

  const back = () => {
    if (image === images[0]) {
      setImage(images[images.length - 1]);
      return image;
    } else {
      images.map((im, index) => {
        if (im === image) {
          setImage(images[index - 1]);
        }
        return image;
      });
    }
    return image;
  };

  return (
    <div className="sticky top-4 bg-white rounded-lg shadow-sm overflow-hidden">
      {/* Image Slider Section */}
      <div className="relative">
        <div className="aspect-w-16 aspect-h-9 bg-gray-100">
          <img
            className="w-full h-full object-contain"
            src={`${URL}/uploads/${image}`}
            alt="Project"
          />
        </div>
        
        {/* Navigation Arrows */}
        <div className="absolute inset-0 flex items-center justify-between p-4">
          <button
            onClick={back}
            className="p-2 rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors"
          >
            <ArrowBackIosNewIcon sx={{ width: 20, height: 20 }} />
          </button>
          <button
            onClick={next}
            className="p-2 rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors"
          >
            <ArrowForwardIosIcon sx={{ width: 20, height: 20 }} />
          </button>
        </div>

        {/* Image Counter */}
        <div className="absolute bottom-4 right-4 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
          {images.indexOf(image) + 1} / {images.length}
        </div>
      </div>

      {/* Job Information Section */}
      <div className="p-6 border-t border-gray-200">
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Job Description
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              {stateSingleJob.jobDescription}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Job Access
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              {stateSingleJob.jobDetails}
            </p>
          </div>
        </div>
      </div>

      {/* Image Thumbnails */}
      <div className="px-6 pb-6 overflow-x-auto">
        <div className="flex space-x-2">
          {images.map((img, index) => (
            <button
              key={index}
              onClick={() => setImage(img)}
              className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-colors ${
                img === image ? 'border-lightgreen' : 'border-transparent'
              }`}
            >
              <img
                src={`${URL}/uploads/${img}`}
                alt={`Thumbnail ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ImageSlider;
